export const USER_DATA = 'UserData';
export const ORGANIZATION_USER_ORG_DATA = 'OrganizationUserOrgData';
//# sourceMappingURL=user.js.map